import Api from "../../../services/api";
import * as types from "../../types";

/**
 * @copyright 2026 @ DigiNet
 * @author YENNHI
 * @create 2026/06/10 09:35
 * @update 2026/06/10 09:35
 */

export function loadGrid(param, cb) {
    return (dispatch) => {
        Api.put('/W05F2040/load-form', param)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                    dispatch(loadGridComplete(result.data));
                }
            });
    };
}

function loadGridComplete(data) {
    return {
        type: types.W05_W05F2040_DATAGRID_COMPLETE,
        dataGrid: data
    };
}

export function deleteGrid(param, cb) {
    return () => {
        Api.delete('/w05f2040/delete', param)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}
export function checkEdit(param, cb) {
    return () => {
        Api.put('/w05f2040/check-edit', param)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

// Cbo Inventory and decimal
export function loadCboInventoryAndDecimal(param, cb) {
    return (dispatch) => {
        Api.put('/W19F1000/get-list', param)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                    dispatch(loadCboInventoryAndDecimalComplete(result.data));
                }
            });
    };
}


function loadCboInventoryAndDecimalComplete(data) {
    return {
        type: Object.keys(data[0]).includes("OriginalDecimal")
            ? types.W05_W05F2040_DECIMAL_COMPLETE
            : types.W05_W05F2040_CBO_INVENTORY_COMPLETE,
        data,
    };
}

export function loadCbow05f2040(param, cb) {
    return () => {
        Api.put('/w05f2040/load-combo', param)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function getNumValue(param, cb) {
    return (dispatch) => {
        Api.put('/W19F1000/get-num-value', param)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                    dispatch(getNumValueComplete(result.data));
                }
            });
    };
}

function getNumValueComplete(data) {
    return {
        type: types.W05_W05F2040_NUMVALUE_COMPLETE,
        numValue: data
    };
}